import {getBlobUrl} from "../utils/api";

export function getRegistersExportFile() {
    return async dispatch => await dispatch(getBlobUrl("/export/registers"));
}